<script setup lang="ts">
import MainNav from "@/components/MainNav.vue";
import Footer from "@/components/Footer.vue";
import "bootstrap-icons/font/bootstrap-icons.css";
import { sessionStore } from "@/stores/Session";
import { watch, useTemplateRef } from "vue";

const mainNavRef = useTemplateRef("mainNav");
watch(
  () => sessionStore().session,
  (newSession) => {
    if (newSession) {
      mainNavRef.value.updateMenubar();
    }
  }
);
</script>

<template>
  <div id="app">
    <MainNav ref="mainNav" />
    <router-view class="container-xxl my-3" />
    <Footer />
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
